import {
   ChronicDiseaseQuery,
   ChronicDiseaseSimpleQuery,
   GynecologicalInterviewQuery,
   MedicalImagingQuery,
   MedicalInformationCountByTypeQuery,
   MedicalInformationQuery,
} from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { refetchCqrsQuery } from '@dreryk/command-query-react-common';

export const refetchAllMedicalInformation = async (): Promise<void> => {
   await Promise.all([
      refetchCqrsQuery(MedicalInformationQuery),
      refetchCqrsQuery(GynecologicalInterviewQuery),
      refetchCqrsQuery(ChronicDiseaseSimpleQuery),
      refetchCqrsQuery(ChronicDiseaseQuery),
      refetchCqrsQuery(MedicalInformationCountByTypeQuery),
      refetchCqrsQuery(MedicalImagingQuery),
   ]);
};
